import { useUI } from "providers/UIProvider"
import { Box, } from "@chakra-ui/react"
import Modal from "components/UI/organisms/Modal"
import BookingsToolbar from "components/templates/ReservationsTemplate/ReservationsToolbar"
import BookingsTable from "components/templates/ReservationsTemplate/ReservationsTable"

const ClientReservationsModal = () => {
  const { modals, toggleModal, T } = useUI()

  return (
    <Modal
      isOpen={modals.clientReservationsModal.isOpened}
      onClose={() => toggleModal("clientReservationsModal", false)}
      title={T("bookings.table.title")}
      styles={{
        headerPadding: "20px 15px 20px 23px",
        width: "93%",
        bodyPadding: "0px 0px 0px 0px",
      }}
    >
      <Box mt={"20px"}>
        <BookingsToolbar />
        <BookingsTable />
      </Box>
    </Modal>
  )
}

export default ClientReservationsModal
